// main.js

// import "lazysizes"; // For use with lazysizes_support config option

import Disclosure from "./scripts/utils/Disclosure.js";
import Dialog from "./scripts/utils/Dialog.js";
import SiteBanner from "./scripts/components/SiteBanner.js";

import Smartcrop from "./scripts/components/Smartcrop.js";
import CogCredits from "./scripts/components/CogCredits.js";
import CogBooking from "./scripts/components/CogBooking.js";
import LoadingIndicator from "./scripts/components/LoadingIndicator.js";
import SiteHeader from "./scripts/components/SiteHeader.js";
import BurgerMenu from "./scripts/components/BurgerMenu.js";
import CardContent from "./scripts/components/CardContent.js";
import SiteCarousels from "./scripts/components/SiteCarousels.js";
import SiteSearch from "./scripts/components/SiteSearch.js";
import SiteTitles from "./scripts/components/SiteTitles.js";

// Flex blocks.
import VimeoHeroVideo from "./scripts/components/VimeoHeroVideo.js";
import HomeHeroCarousel from "./scripts/components/HomeHeroCarousel.js";

import Accordion from "./scripts/components/flex/Accordion.js";
import MediaGallery from "./scripts/components/flex/MediaGallery.js";
import OpeningTimesBlock from "./scripts/components/flex/OpeningTimesBlock.js";
import GmapVisitBlock from "./scripts/components/flex/GMapVisitBlock.js";
import SupportBlock from "./scripts/components/flex/SupportBlock.js";
import RelatedContent from "./scripts/components/flex/RelatedContent.js";
import TabBlocks from "./scripts/components/flex/TabBlocks.js";
import EventFeed from "./scripts/components/flex/EventFeed.js";
import LoadMoreInstances from "./scripts/utils/LoadMoreInstances.js";
import Reviews from "./scripts/components/flex/Reviews.js";
import EventInstancesFilter from "./scripts/components/EventInstancesFilter.js";
import Memberships from "./scripts/components/Memberships.js";
import EventNav from "./scripts/components/flex/EventNav.js";

import GoogleMapsStatic from "./scripts/components/GoogleMapsStatic.js";
import SpektrixSession from "./scripts/components/SpektrixSession.js";
import SpektrixIframe from "./scripts/components/SpektrixIframe.js";

// Disable membership upsale block - Pending: This will now be implemented on React.
// See: https://app.clickup.com/t/86992m6mb
//import CustomBlockSpektrix from "./scripts/components/CustomBlockSpektrix.js";

import SpektrixLogin from "./scripts/components/SpektrixLogin.js";

//import MultiSelect from "./scripts/components/CogMultiSelect.js";
//import MultiSelectItem from "./scripts/components/CogMultiSelectItem.js";

// @feature custom-seating-plan
// import SeatingPlan from "./scripts/components/SeatingPlan.js";

document.addEventListener("DOMContentLoaded", () => {
    window.spektrix_session = new SpektrixSession();
});


// Limit under 30 form DOB date picker.
if (window.hasOwnProperty("gform")) {
    const data = {
        formId: 7,
        fieldId: 17, // Date picker ID on form.
    };

    window.gform.addFilter(
        "gform_datepicker_options_pre_init",
        function (options, formId, fieldId) {
            if (formId == data.formId && fieldId == data.fieldId) {
                options.minDate = "-30Y";
                options.maxDate = 0;
            }
            return options;
        },
    );
}
